export default __webpack_public_path__ + "static/media/position-share-bg.7898d9d6.png";